
import React from 'react';
import { Button } from "@/components/ui/button";
import { RotateCcwIcon } from "lucide-react";

interface LinkResetButtonProps {
  onReset: () => void;
}

const LinkResetButton: React.FC<LinkResetButtonProps> = ({ onReset }) => {
  return (
    <Button 
      variant="outline" 
      size="sm" 
      onClick={onReset}
      className="text-xs"
    >
      <RotateCcwIcon className="h-3 w-3 mr-1" />
      New Place
    </Button>
  );
};

export default LinkResetButton;
